var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isAllowed
    ? _c(
        "app-pending-tasks",
        { staticClass: "set-height", attrs: { tasks: _vm.tasks } },
        [
          _c("template", { slot: "title" }, [
            _vm._v(" " + _vm._s(_vm.title) + " "),
          ]),
        ],
        2
      )
    : _c("app-missing-module", {
        attrs: { "module-id": 76, title: _vm.title, "disable-max-width": "" },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }